import React, { useEffect, useState } from 'react';
import { formatCurrency, apiFetch } from "utils";
import PropTypes from 'prop-types';
import registeredComponent from 'utils/registeredComponent';
import Placeholder from 'components/Placeholder';
import TotalsHeader from '../shared/TotalsHeader'

/**
 * Shows a header with the totals for the fields listed in the columns prop.
 */
const TuitionAndFeesTotalsHeader = ({columns, pageName, pageFilterId, schoolYearId}) => {
  const [ready, setReady] = useState(false);
  const [totals, setTotals] = useState({});

  useEffect(
    () => {
      const params = new URLSearchParams({
        page_name: pageName,
        page_filter_id: pageFilterId,
        school_year_id: schoolYearId,
      });

      apiFetch.get(totals, `tuition_and_fees/summary?${params.toString()}`)
        .then(json => {
          setTotals(json);
          setReady(true);
      });
    }, []
  );

  let columnValues = columns.map((column) => formatCurrency(totals[column.name]));

  return (
    <Placeholder.loading ready={ready}>
      <TotalsHeader columnHeaders={columns.map((column) => column.public_name)} columnValues={columnValues} />
    </Placeholder.loading>
  );
}

TuitionAndFeesTotalsHeader.propTypes = {
  columnHeaders: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, public_name: PropTypes.string })),
  pageName: PropTypes.string,
  pageFilterId: PropTypes.string,
  schoolYearId: PropTypes.string,
};

TuitionAndFeesTotalsHeader.defaultProps = {
  columnHeaders: [],
  pageName: "",
  pageFilterId: "",
  schoolYearId: "",
};

export default registeredComponent("TuitionAndFeesTotalsHeader")(TuitionAndFeesTotalsHeader);
